



































































































































































































































































import Vue from "vue";
import TextTransition from "../Libraries/TextTransition";
import { Sprite } from "three";

const textTransition = new TextTransition();

export default Vue.extend({
  data() {
    return {
      staments: [
        {
          actions: ["design", "develop"],
          object: "Video Games"
        },
        {
          actions: ["architecture", "code"],
          object: "Frontend Applications"
        },
        {
          actions: ["design", "develop"],
          object: "Augmented Reality"
        },
        {
          actions: ["architecture", "code"],
          object: "Backend Applications"
        },
        {
          actions: ["design", "develop"],
          object: "Web Applications"
        },
        {
          actions: ["research", "design"],
          object: "UI/UX"
        },
        {
          actions: ["architecture", "develop"],
          object: "Mobile Applications"
        },
        {
          actions: ["design", "code"],
          object: "Digital Experiences"
        }
      ],
      currentStatement: {
        actions: ["architecture", "develop"],
        object: "Frontend Applications"
      },
      current: -1,
      timeTransition: 7000,
      animationTime: NaN
    };
  },
  mounted() {
    this.nextSkill();
  },
  computed: {
    action1() {
      return this.$data.currentStatement.actions[0];
    },
    action2() {
      return this.$data.currentStatement.actions[1];
    },
    object() {
      return this.$data.currentStatement.object;
    }
  },
  methods: {
    nextStatement() {
      this.$data.current++;
      if (this.$data.current >= this.$data.staments.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$data.current = 0;
      }
      return this.$data.staments[this.$data.current];
    },
    nextSkill() {
      const comp = this;
      const nextSt = comp.nextStatement();
      this.$data.currentStatement.actions = nextSt.actions;
      textTransition.AnimateTextTransition(
        comp.$data.currentStatement.object,
        nextSt.object,
        45,
        22,
        (intermediate: string, done: boolean) => {
          if (done) {
            setTimeout(function() {
              comp.nextSkill();
            }, 2000);
          } else {
            comp.$data.currentStatement.object = intermediate;
          }
        }
      );
    }
  }
});
